import React from 'react';
import { SessionFieldsFragment } from '../../../generated/core-api/graphql-react-query';
import { SessionComplianceChecklistItem } from '../NewSessionContext/Contexts/SessionComplianceContextProvider/type';
import { LatestDetection } from '../NewSessionContext/Contexts/SessionDetectionContextProvider/useSessionDetectionContext';

export interface SessionContextProps {
  sessionId: string | null;
  session: SessionFieldsFragment | null | undefined;
  sessionLoading: boolean;
  startSession: () => void;
  stopSession: () => void;
  context: string | null;
  setContext: React.Dispatch<React.SetStateAction<string | null>>;
  compliance: SessionComplianceChecklistItem[] | null;
  latestDetection: LatestDetection | null;
  detectionHistory: (LatestDetection & { cardTitle?: string, commandTitle?: string })[];
  focusMode: boolean;
  setFocusMode: () => void;
}

export const SessionContext = React.createContext<SessionContextProps | null>(null);

export default function useSessionContext() {
  const context = React.useContext(SessionContext);
  if (!context) {
    throw new Error('useSessionContext must be used within a SessionContextProvider');
  }

  return context;
}
